module.exports = __webpack_public_path__ + "static/media/logo_1100.61f04ed7.png";